/**
 * Page content controlled by CMS references a single id for entry in contentful
 */
export const HOMEPAGE_ID = '25ObcWcUBVHtVugad9ss6i';
export const COLLECTORS_PAGE_ID = '41u7WB21nqcjeq7mY0sVj';
export const PATRON_PASS_PAGE_ID = '4FIE6Oq8rbQ8AcVVcPkRNO';
export const COMMUNITY_PROJECTS_PAGE_ID = '1PHtHFSvEKSiTTcuHR5GDf';
